import template from './component.tpl.html';
import AlMediaManagerDirectoryTreeController from './controller';

angular
    .module('festzelt-os.modules.media')
    .component('alMediaManagerDirectoryTree', {
        bindings: {
            directories: '<',
            parentDirectory: '<',
            refresh: '<',
            depthLevel: '<',
            currentActiveDirectory: '<',
            onDirectoryClick: '&'
        },
        controller: AlMediaManagerDirectoryTreeController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-manager/sub-components/directory-tree/component.js